import Chaintext from "../Chaintext/Chaintext";
import { React, useState, useEffect } from "react";

function Results(props) {
  const e = " ..... ";
  const [ChainPartResult, setChainPartResult] = useState("");
  const [active, setActive] = useState(-1);

  useEffect(() => {
    setActive(-1);
    setChainPartResult("");
    // console.log("refresz child");
  }, [props.refresh]);

  const handleClickLi = (item, i) => {
    setChainPartResult(item);
    setActive(i);
  };

  let listItems = [...props.partsmass.entries()].map(([number, num], index) => (
    <li
      key={index}
      className={active == index ? "active" : ""}
      onClick={() => handleClickLi(number, index)}
    >
      {number + e + num/100000 + e + Math.abs(num - props.out_mass)/100000}
    </li>
  ));

  // console.log("render Results");

  return (
    <>
      <div id="Chaintextwrapper">
        <Chaintext peptid={props.peptid} fraza={ChainPartResult}></Chaintext>
      </div>
      <ul>{listItems}</ul>
    </>
  );
}

export default Results;
